var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    fillRule: "evenodd",
    d: "M1.342 4.454c0-.547.444-.991.991-.991h15.91c.547 0 .99.444.99.991v13.788c0 .548-.443.992-.99.992H2.332c-.547 0-.991-.444-.991-.992V4.454zm1.983.992V17.25H17.25V5.446H3.325z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    fillRule: "evenodd",
    d: "M17.25 9.757c0-.548.445-.992.992-.992h4.243c.263 0 .516.105.702.29l3.181 3.183c.186.186.29.439.29.702v5.302c0 .548-.444.992-.991.992h-7.425c-.547 0-.992-.444-.992-.992V9.757zm1.984.992v6.501h5.441v-3.9l-2.6-2.601h-2.841zM7.106 19.234c-.916 0-1.66.743-1.66 1.66 0 .917.744 1.66 1.66 1.66.917 0 1.66-.743 1.66-1.66 0-.917-.743-1.66-1.66-1.66zm-3.643 1.66c0-2.012 1.631-3.644 3.643-3.644 2.013 0 3.644 1.631 3.644 3.644 0 2.012-1.631 3.643-3.644 3.643-2.012 0-3.643-1.631-3.643-3.643z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    fillRule: "evenodd",
    d: "M20.894 19.234c-.917 0-1.66.743-1.66 1.66 0 .917.743 1.66 1.66 1.66.917 0 1.66-.743 1.66-1.66 0-.917-.743-1.66-1.66-1.66zm-3.643 1.66c0-2.012 1.63-3.644 3.643-3.644 2.012 0 3.644 1.631 3.644 3.644 0 2.012-1.632 3.643-3.644 3.643-2.012 0-3.643-1.631-3.643-3.643z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountDelivery);
export default __webpack_public_path__ + "static/media/account-delivery.36cb5367f673cdef4e1ab79b4b989749.svg";
export { ForwardRef as ReactComponent };